import actions from './actions';
import reducers from './reducers';
import localStorage from './localStorage.js';

const redux = {
  actions,
  reducers,
  localStorage,
};

export default redux;
